import {
  Tire,
  TireEditFormValues,
  TireManufacturer,
  TireManufacturerRow,
  TireRow,
} from "./types";

/*---------------------------------------------------------------------------------------
   TIRE 
-----------------------------------------------------------------------------------------*/

export const transformTire = (res: any): Tire => {
  return {
    id: res.id,
    width: res.width,
    height: res.height,
    radius: res.radius,
    manufacturers: res.manufacturers.map(transformTireManufacturer),
    changePrice: res.changePrice,
    hotelPrice: res.hotelPrice,
  };
};

export const transformTireManufacturer = (res: any): TireManufacturer => {
  return {
    id: res.id,
    price: res.price,
    tireManufacturer: {
      id: res.tireManufacturer.id,
      name: res.tireManufacturer.name,
    },
  };
};

export const transformTireManufacturerPrice = (
  manufacturers: TireManufacturer[],
  tireManufacturerId: string
): any => {
  let isArray = Array.isArray(manufacturers);
  if (!isArray) return "";

  const manufacturer = manufacturers.find(
    (m) => m.tireManufacturer?.id === tireManufacturerId
  );

  if (!manufacturer) return "";

  return manufacturer.price;
};

/*---------------------------------------------------------------------------------------
   TIRE SEARCH
-----------------------------------------------------------------------------------------*/

export const transformTireRow = (res: any): TireRow => {
  return {
    id: res.id,
    width: res.width,
    height: res.height,
    radius: res.radius,
    changePrice: res.changePrice,
    hotelPrice: res.hotelPrice,
  };
};

/*---------------------------------------------------------------------------------------
     TIRE CREATE
  -----------------------------------------------------------------------------------------*/

export const transformTireOnCreate = (formValues: TireEditFormValues): any => {
  return {
    width: formValues.width,
    height: formValues.height,
    radius: formValues.radius,
    changePrice: formValues.changePrice,
    hotelPrice: formValues.hotelPrice,
    manufacturers: formValues.manufacturers.map(
      transformTireManufacturerOnCreate
    ),
  };
};

export const transformTireManufacturerOnCreate = (
  formValues: TireManufacturer
): any => {
  return {
    tireManufacturerId: formValues.tireManufacturer?.id,
    price: formValues.price,
  };
};

/*---------------------------------------------------------------------------------------
   TIRE EDIT
-----------------------------------------------------------------------------------------*/

export const transformTireOnUpdate = (formValues: TireEditFormValues): any => ({
  id: formValues.id,
  width: formValues.width,
  height: formValues.height,
  radius: formValues.radius,
  changePrice: formValues.changePrice,
  hotelPrice: formValues.hotelPrice,
  manufacturers: formValues.manufacturers.map(
    transformTireManufacturerOnCreate
  ),
});

/*---------------------------------------------------------------------------------------
   TIRE MANUFACTURER SEARCH
-----------------------------------------------------------------------------------------*/

export const transformTireManufacturerRow = (res: any): TireManufacturerRow => {
  return {
    id: res.id,
    name: res.name,
    image: res.image ?? null,
    primary: res.primary ?? false,
    displayOrder: res.displayOrder ?? 0,
  };
};
